const MAX_DISMISSALS = 3;
const COOLDOWN_MS = 24 * 60 * 60 * 1000;

const storageKey = (userId) => `intervend_promo_dismissed_${userId || "anon"}`;

const readState = (userId) => {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return { count: 0, lastShownAt: 0 };
    const parsed = JSON.parse(raw);
    return {
      count: Number(parsed.count) || 0,
      lastShownAt: Number(parsed.lastShownAt) || 0,
    };
  } catch {
    return { count: 0, lastShownAt: 0 };
  }
};

const writeState = (userId, state) => {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(state));
  } catch {
    // localStorage unavailable (private mode, quota) — silently ignore
  }
};

export const getDismissCount = (userId) => readState(userId).count;

export const shouldShow = (userId) => {
  const { count, lastShownAt } = readState(userId);
  if (count >= MAX_DISMISSALS) return false;
  if (!lastShownAt) return true;
  return Date.now() - lastShownAt >= COOLDOWN_MS;
};

export const markShown = (userId) => {
  const state = readState(userId);
  writeState(userId, { ...state, lastShownAt: Date.now() });
};

export const incrementDismiss = (userId) => {
  const state = readState(userId);
  writeState(userId, {
    count: state.count + 1,
    lastShownAt: Date.now(),
  });
};

export const markPermanentlyDismissed = (userId) => {
  writeState(userId, { count: MAX_DISMISSALS, lastShownAt: Date.now() });
};

export { MAX_DISMISSALS };
